import findResult, {
  assignIfExists,
  findItemByMemberID,
  isValidFilter,
  removeItemByMemberID,
  selectableResult,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import { findAllCohorts, findCohort } from '../../state/shared';
import sharingCohort, {
  findCohortMembers, cohortMembers, newCohortMember, cohortPermsFromArray,
} from './state';
import actions, { cohortPermissionGroups } from '../constants';

const hideShareCohort = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  draft.sharingCohort = sharingCohort();
  item.members = cohortMembers(10000);
  item.unassignedMembers = cohortMembers(20, 3, true);
});

const showShareCohort = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  draft.sharingCohort.open = true;
  draft.sharingCohort.category = action.category;
  draft.sharingCohort.code = action.code;
  item.members = cohortMembers(10000);
  item.unassignedMembers = cohortMembers(20, 3, true);
});

const updateCohortMembersProperties = withDraft((draft, action) => {
  const members = findCohortMembers(draft, action);
  assignIfExists(members, action.properties);
});

const fetchCohortMembers = withDraft((draft, action) => {
  const members = findCohortMembers(draft, action);
  members.filter = action.filter;
  members.results = [];
  members.readStatus = isValidFilter(action.filter, members) ? states.PENDING : states.NONE;
  members.readErrors = [];
});

const showCohortMembers = withDraft((draft, action) => {
  const members = findCohortMembers(draft, action);
  const results = action.results.map(selectableResult);
  members.readStatus = states.SUCCESS;
  members.readErrors = [];
  members.results = results;
  members.original = results;
  members.count = action.resultsCount;
});

const showCohortMembersError = withDraft((draft, action) => {
  const members = findCohortMembers(draft, action);
  members.readStatus = states.ERROR;
  members.readErrors = [responseError(action)];
});

const addCohortMembers = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  const perms = cohortPermsFromArray(cohortPermissionGroups[draft.sharingCohort.permissionGroup]);
  const membersToAdd = draft.sharingCohort.membersToAdd.map((user) => newCohortMember(user, perms));
  draft.sharingCohort.membersToAdd = [];
  item.members.results = item.members.results.concat(membersToAdd);
  item.unassignedMembers.filter = '';
});

const removeCohortMember = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  item.members.results = removeItemByMemberID(item.members.results, action.memberID);
});

const updateCohortMemberPermissions = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  const member = findItemByMemberID(item.members.results, action.memberID);
  member.permissions = cohortPermsFromArray(cohortPermissionGroups[action.permissions]);
});

const shareCohortSuccessOrError = withDraft((draft) => { draft.sharingCohort = sharingCohort(); });

const updateCurrentCohortPermissions = withDraft((draft, { code, permissions }) => {
  findAllCohorts(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.cohorts, category, code);
    item.permissions = permissions;
  });
});

const updateShareCohortProperties = withDraft((draft, { properties }) => {
  assignIfExists(draft.sharingCohort, properties);
});

const shareCohort = withDraft((draft) => {
  draft.sharingCohort.saveStatus = states.PENDING;
});

export default {
  [actions.ADD_COHORT_MEMBERS]: addCohortMembers,
  [actions.FETCH_COHORT_MEMBERS]: fetchCohortMembers,
  [actions.HIDE_SHARE_COHORT]: hideShareCohort,
  [actions.REMOVE_COHORT_MEMBER]: removeCohortMember,
  [actions.SHARE_COHORT]: shareCohort,
  [actions.SHARE_COHORT_ERROR]: shareCohortSuccessOrError,
  [actions.SHARE_COHORT_SUCCESS]: shareCohortSuccessOrError,
  [actions.SHOW_COHORT_MEMBERS]: showCohortMembers,
  [actions.SHOW_COHORT_MEMBERS_ERROR]: showCohortMembersError,
  [actions.SHOW_SHARE_COHORT]: showShareCohort,
  [actions.UPDATE_COHORT_MEMBER_PERMISSIONS]: updateCohortMemberPermissions,
  [actions.UPDATE_COHORT_MEMBERS_PROPERTIES]: updateCohortMembersProperties,
  [actions.UPDATE_CURRENT_COHORT_PERMISSIONS]: updateCurrentCohortPermissions,
  [actions.UPDATE_SHARE_COHORT_PROPERTIES]: updateShareCohortProperties,
};
